import { render, staticRenderFns } from "./case-automatic-notification-trigger-modal.vue?vue&type=template&id=5f3826aa&"
import script from "./case-automatic-notification-trigger-modal.ts?vue&type=script&lang=ts&"
export * from "./case-automatic-notification-trigger-modal.ts?vue&type=script&lang=ts&"
import style0 from "./case-automatic-notification-trigger-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports